import { Component, EventEmitter, Output } from '@angular/core';
import { GoogleAnalyticService } from '@services';
import { BreakpointService } from 'app/services/breakpoint-observer.service';

@Component({
  selector: 'app-invoice-navbar',
  templateUrl: './invoice-navbar.component.html',
  styleUrls: ['./invoice-navbar.component.scss'],
})
export class InvoiceNavbarComponent {
  @Output() exitForm = new EventEmitter<boolean>();

  isMobile$ = this.breakpointService.isMobile$;
  isDesktop$ = this.breakpointService.isDesktop$;

  constructor(
    private googleAnalyticsService: GoogleAnalyticService,
    private breakpointService: BreakpointService,
  ) {
  }

  exit(): void {
    this.exitForm.emit();
    this.googleAnalyticsService.track('analitics', `invoice-header.logo`, {
      eventLabel: 'logo_exit_click',
      eventCategory: 'invoice',
      eventAction: 'click',
    });
  }
}
